import {
  faBuilding,
  faBullseyePointer,
  faComments,
  faEnvelope,
  faGavel,
  faMap,
  faPenToSquare,
  faQuestionCircle,
  faUser,
} from '@awesome.me/kit-4a6bf60416/icons/classic/regular';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { PageType } from '@/types/page';

export interface PageTemplate {
  key: string;
  label: string;
  description: string;
  icon: IconDefinition;
}

export interface IndexPageType {
  key: PageType.REVIEW_INDEX | PageType.CASE_RESULT_INDEX | PageType.BLOG_INDEX;
  label: string;
  description: string;
  icon: IconDefinition;
}

export const PAGE_TEMPLATES: PageTemplate[] = [
  {
    key: PageType.PROFILE,
    label: 'Profile',
    description: 'Introduce yourself or your team',
    icon: faUser,
  },
  {
    key: PageType.PRACTICE_AREA,
    label: 'Practice Area',
    description: 'Describe your legal services',
    icon: faBuilding,
  },
  {
    key: PageType.FAQ,
    label: 'FAQ',
    description: 'Answer frequently asked questions',
    icon: faQuestionCircle,
  },
  {
    key: PageType.OFFICE,
    label: 'Office',
    description: 'Share office and contact details',
    icon: faMap,
  },
  {
    key: PageType.CONTACT,
    label: 'Contact',
    description: 'Let clients get in touch easily',
    icon: faEnvelope,
  },
  {
    key: PageType.LANDING_PAGE,
    label: 'Landing Page',
    description: 'Promote ad campaigns',
    icon: faBullseyePointer,
  },
];

export const INDEX_PAGE_TYPES: IndexPageType[] = [
  {
    key: PageType.REVIEW_INDEX,
    label: 'Reviews',
    description: 'Showcase client testimonials',
    icon: faComments,
  },
  {
    key: PageType.CASE_RESULT_INDEX,
    label: 'Case Results',
    description: 'Share successful client outcomes',
    icon: faGavel,
  },
  {
    key: PageType.BLOG_INDEX,
    label: 'Blog',
    description: 'Publish news, updates, or articles',
    icon: faPenToSquare,
  },
];

export const BLANK_PAGE_OPTION = { key: 'blank' as const };

export type SidebarSelection = string | null;

export const CASE_RESULT_LAYOUT_HEADER = {
  pageType: PageType.CASE_RESULT,
  title: 'Case Result',
  description:
    'Select a layout for your Case Result pages. This layout can be changed at any time.',
};

export const BLOG_LAYOUT_HEADER = {
  pageType: PageType.BLOG,
  title: 'Blog',
  description: 'Select a layout for your Blog posts. This layout can be changed at any time.',
};

export const LAYOUT_HEADERS = [
  CASE_RESULT_LAYOUT_HEADER,
  BLOG_LAYOUT_HEADER,
  {
    pageType: PageType.REVIEW_INDEX,
    title: 'Reviews',
    description:
      'Select a layout for displaying Reviews on your index page. This layout can be changed at any time.',
  },
  {
    pageType: PageType.BLOG_INDEX,
    title: 'Blogs',
    description:
      'Select a layout for displaying published Blog Posts on your index page. This layout can be changed at any time.',
  },
  {
    pageType: PageType.CASE_RESULT_INDEX,
    title: 'Case Results',
    description:
      'Select a layout for displaying published Case Results on your index page. This layout can be changed at any time.',
  },
];
